export default "__VITE_ASSET__BTC_ewMF__"